var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { jsx as _jsx } from "react/jsx-runtime";
// import { GlobalContext } from '../../context/global'
import styled from 'styled-components';
export default function Pagination(_a) {
    var max = _a.max, current = _a.current;
    var array = Array.from({ length: max }, function (_, index) { return index + 1; });
    return (_jsx(PaginationContainer, { children: array.map(function (index) {
            return _jsx(Bullet, { active: current === index }, index);
        }) }));
}
var PaginationContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  gap: 8px;\n  justify-content: center;\n  margin: 24px 0;\n"], ["\n  display: flex;\n  gap: 8px;\n  justify-content: center;\n  margin: 24px 0;\n"])));
var Bullet = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  background-color: ", ";\n  border-radius: 50%;\n  height: 14px;\n  width: 14px;\n"], ["\n  background-color: ", ";\n  border-radius: 50%;\n  height: 14px;\n  width: 14px;\n"])), function (_a) {
    var active = _a.active, theme = _a.theme;
    return (active ? theme.palette.purple : theme.palette.layoutCardLight);
});
var templateObject_1, templateObject_2;
